"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var TableActionDelete_1 = require("../../../../../../../shared/components/table_actions/TableActionDelete");
var TableActionEdit_1 = require("../../../../../../../shared/components/table_actions/TableActionEdit");
var WrapTableActions_1 = require("../../../../../../../shared/components/table_actions/WrapTableActions");
var notificationHelper_1 = require("../../../../../../../shared/helpers/notificationHelper");
var ToolBarButtonsOnly_1 = require("../../../../../../../shared/components/toolbars/ToolBarButtonsOnly");
var PlayerLevelBetAmountsList = /** @class */ (function (_super) {
    __extends(PlayerLevelBetAmountsList, _super);
    function PlayerLevelBetAmountsList(props) {
        var _this = _super.call(this, props) || this;
        _this.columns = [
            {
                title: 'Уровень',
                dataIndex: _this.props.data.dk_bonus_level_title,
                key: _this.props.data.dk_bonus_level_title,
                width: 150,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, _this.props.rootRecord.title));
                }
            }, {
                title: 'Валюта',
                dataIndex: _this.props.data.dk_app_currency_title,
                key: _this.props.data.dk_app_currency_title,
                width: 100,
                align: "center"
            }, {
                title: 'Мин сумма ставок',
                dataIndex: _this.props.data.dk_min_bet_amount,
                key: _this.props.data.dk_min_bet_amount,
                width: 100,
            }, {
                title: 'Пойнты',
                children: [{
                        title: 'Курс обмена',
                        dataIndex: _this.props.data.dk_points_exchange_money_price,
                        key: _this.props.data.dk_points_exchange_money_price,
                        width: 100,
                        render: function (text, record, idx) {
                            return (React.createElement("div", null, record.points_exchange_money_price + " => 1"));
                        }
                    }, {
                        title: 'Мин. сумма',
                        dataIndex: _this.props.data.dk_points_exchange_min_amount,
                        key: _this.props.data.dk_points_exchange_min_amount,
                        width: 100,
                        render: function (text, record, idx) {
                            return (React.createElement("div", null, record.points_exchange_min_amount));
                        }
                    }]
            }, {
                title: 'Кэшбек',
                children: [{
                        title: 'Процент',
                        dataIndex: _this.props.data.dk_cashback_bonus_percent_x100,
                        key: _this.props.data.dk_cashback_bonus_percent_x100,
                        width: 100,
                        render: function (text, record, idx) {
                            return (React.createElement("div", null, record.cashback_bonus_percent_x100 + "%"));
                        }
                    }, {
                        title: 'Вейджер',
                        dataIndex: _this.props.data.dk_cashback_bonus_wager,
                        key: _this.props.data.dk_cashback_bonus_wager,
                        width: 100,
                        render: function (text, record, idx) {
                            return (React.createElement("div", null, record.cashback_bonus_wager));
                        }
                    }]
            }, {
                title: 'День рождения',
                children: [{
                        title: 'Сумма',
                        dataIndex: _this.props.data.dk_birthday_bonus_amount,
                        key: _this.props.data.dk_birthday_bonus_amount,
                        width: 100,
                        render: function (text, record, idx) {
                            return (React.createElement("div", null, "" + record.birthday_bonus_amount));
                        }
                    }, {
                        title: 'Вейджер',
                        dataIndex: _this.props.data.dk_birthday_bonus_wager,
                        key: _this.props.data.dk_birthday_bonus_wager,
                        width: 100,
                        render: function (text, record, idx) {
                            return (React.createElement("div", null, record.birthday_bonus_wager));
                        }
                    }]
            }, {
                title: 'Достижение уровня',
                children: [{
                        title: 'Сумма',
                        dataIndex: _this.props.data.dk_level_access_bonus_amount,
                        key: _this.props.data.dk_level_access_bonus_amount,
                        width: 100,
                        render: function (text, record, idx) {
                            return (React.createElement("div", null, "" + record.level_access_bonus_amount));
                        }
                    }, {
                        title: 'Вейджер',
                        dataIndex: _this.props.data.dk_level_access_bonus_wager,
                        key: _this.props.data.dk_level_access_bonus_wager,
                        width: 100,
                        render: function (text, record, idx) {
                            return (React.createElement("div", null, record.level_access_bonus_wager));
                        }
                    }]
            }, {
                title: 'Действия',
                key: 'action',
                align: "center",
                render: function (text, record, idx) { return (React.createElement(WrapTableActions_1.default, null,
                    React.createElement(TableActionEdit_1.default, { hint: "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C", onClick: function () { _this.onEditPlayerClick(record); } }),
                    React.createElement(TableActionDelete_1.default, { hint: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C", confirmText: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u0443 \u0437\u0430\u043F\u0438\u0441\u044C ?", onClick: function () { _this.onDeleteClick(record); } }))); },
                width: 100
            }
        ];
        return _this;
    }
    PlayerLevelBetAmountsList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.data.Subscribe("*", function (id, data) {
            _this.setState({
                data: data.data,
                totalRows: data.total
            });
        });
        this.setState({
            data: this.props.data.DATA.data,
            pageNum: this.props.pageNum,
            pageSize: this.props.pageSize,
            totalRows: 0
        }, function () {
            _this.props.data.LoadData(_this.props.rootRecord.key);
        });
    };
    PlayerLevelBetAmountsList.prototype.componentWillUnmount = function () {
        this.props.data.UnSubscribe(this.SID);
    };
    PlayerLevelBetAmountsList.prototype.componentWillReceiveProps = function (nextProps) {
        var _this = this;
        if (nextProps) {
            this.setState({
                pageNum: nextProps.pageNum,
                pageSize: nextProps.pageSize
            }, function () {
                nextProps.data.LoadData(_this.props.rootRecord.key);
            });
        }
    };
    PlayerLevelBetAmountsList.prototype.onEditPlayerClick = function (record) {
        if (this.props.onEditClick) {
            this.props.onEditClick(record);
        }
    };
    PlayerLevelBetAmountsList.prototype.onDeleteClick = function (record) {
        this.props.data.DeleteData(record.key, function () {
            notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                "\u041F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u044B \u0441\u0442\u0430\u0432\u043E\u043A \u0434\u043B\u044F \u0443\u0440\u043E\u0432\u043D\u044F ",
                React.createElement("b", null,
                    "[",
                    record.bonus_level_title,
                    "]"),
                " \u0431\u044B\u043B\u0438 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0443\u0434\u0430\u043B\u0435\u043D\u044B"));
        });
    };
    PlayerLevelBetAmountsList.prototype.onPageChanged = function (Page, PageSize) {
        var _this = this;
        var _page = Page;
        if (PageSize != this.state.pageSize) {
            _page = 1;
        }
        this.setState({ pageNum: _page, pageSize: PageSize }, function () {
            if (_this.props.onPageConfigChanged) {
                _this.props.onPageConfigChanged(_page, PageSize);
            }
        });
    };
    PlayerLevelBetAmountsList.prototype.onToolBarClick = function (action) {
        if (action === "refresh") {
            this.props.data.LoadData(this.props.rootRecord.key);
        }
        if (action === "create") {
            if (this.props.onNewClick) {
                this.props.onNewClick();
            }
        }
        if (action === "back") {
            if (this.props.onGoBack) {
                this.props.onGoBack();
            }
        }
    };
    PlayerLevelBetAmountsList.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(ToolBarButtonsOnly_1.default, { hint: { create: "Создать", refresh: "Обновить", back: "Назад" }, onClick: this.onToolBarClick.bind(this) }),
            React.createElement(antd_1.Table, { locale: {
                    filterTitle: 'Поиск',
                    filterConfirm: 'Да',
                    filterReset: 'Сброс',
                    emptyText: 'Нет данных',
                }, bordered: true, columns: this.columns, dataSource: this.state.data, pagination: {
                    pageSize: this.state.pageSize,
                    showSizeChanger: true,
                    current: this.state.pageNum,
                    total: this.state.totalRows,
                    position: "bottom",
                    onChange: this.onPageChanged.bind(this),
                    onShowSizeChange: this.onPageChanged.bind(this),
                    pageSizeOptions: this.props.state.UITablePageSizeOptions,
                    showQuickJumper: true,
                }, footer: function (data) {
                    return React.createElement("div", null,
                        "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u0442\u0441\u044F \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 : ",
                        data.length,
                        " \u0438\u0437 ",
                        _this.state.totalRows,
                        " \u0437\u0430\u043F\u0438\u0441\u0435\u0439");
                }, expandedRowRender: function (record) {
                    return (React.createElement("div", null,
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0437\u0430\u043F\u0438\u0441\u0438:"),
                            " [",
                            record.key,
                            "] "),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0421\u043E\u0437\u0434\u0430\u043D:"),
                            " [",
                            record.date_added.format(_this.props.state.getDateTimeFormat()),
                            "] "),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0418\u0437\u043C\u0435\u043D\u0435\u043D:"),
                            " [",
                            record.date_changed.format(_this.props.state.getDateTimeFormat()),
                            "]")));
                }, scroll: { x: true } })));
    };
    return PlayerLevelBetAmountsList;
}(React.Component));
exports.default = PlayerLevelBetAmountsList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_player_levels/ui/component/cfg_betamounts/PlayerLevelBetAmountsList.tsx
// module id = 1954
// module chunks = 0